import { Typography, Grid, makeStyles } from "@material-ui/core";
import { DARK_GRAY, GRAY, SECONDARY_COLOR } from "../../../theme";
import { UserX } from "react-feather";
import { format } from "date-fns";
import { formatStringField } from "../../utils/Utils";
import { driverLicenseTypes, profileStyle } from "../../utils/enum";
import { useEffect, useState } from "react";
import PoleService from "../../../services/PoleService";

const UserDetailsContent = props => {
  const {
    userData,
    isActiveDriver,
    startValidity,
    isDriver,
    hideTitle,
    hideNameAndRole
  } = props;

  const classes = useStyles();
  const userTerm = isDriver ? "Condutor" : "Responsável";
  const [poles, setPoles] = useState([]);

  const isFacRegional =
    profileStyle.find(e => e.profile === userData.profile?.profileName)?.label ===
    "FAC Regional";

  useEffect(() => {
    if (isFacRegional && userData?.id) {
      PoleService.getPolosByUserId(userData?.id).then(response => {
        setPoles(response.data);
      });
    }
  }, [isFacRegional, userData?.id]);

  return (
    <Grid item container xs={12}>
      {!hideTitle && (
        <Grid container className="mb-4">
          <Typography variant="h6" component="h4" className={classes.header}>
            {`Dados do ${userTerm}`}
          </Typography>
          {!isActiveDriver && (
            <Grid item container xs={12} className="mt-6">
              <UserX className={`mr-4 ${classes.noActiveDriver}`} />
              <Typography variant="body1" className={classes.noActiveDriver}>
                {startValidity
                  ? `Atualmente este veículo não possui nenhum ${userTerm.toLowerCase()} vinculado, os dados apresentados são do último ${userTerm.toLowerCase()}.`
                  : `Este veículo nunca possuiu nenhum ${userTerm.toLowerCase()} vinculado.`}
              </Typography>
            </Grid>
          )}
        </Grid>
      )}

      {userData && (
        <Grid container>
          <Grid item container xs={12} className="mt-2" alignItems="stretch">
            {!hideNameAndRole && (
              <Grid item className={`mr-6 ${classes.fieldContainer}`}>
                <Grid item xs={12} className="mb-4">
                  <Typography variant="body1" className={classes.header}>
                    {formatStringField(userData.name)}
                    <br />
                    {userData.role?.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.fieldLabel}>
                  <Typography variant="caption" component="h5" className={classes.subtitle}>
                    Nome e Cargo
                  </Typography>
                </Grid>
              </Grid>
            )}
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {formatStringField(userData.email)}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  E-mail
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {formatStringField(userData.adUser)}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  ID Yara
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {formatStringField(userData.costCenter?.name)}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Cód. Centro de Custo
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" component="div" className={classes.header}>
                  {isFacRegional
                    ? poles.map(p => (
                        <span key={p.id} className={classes.poleTag}>
                          {p.name}
                        </span>
                      ))
                    : formatStringField(userData.pole?.name)}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Polo
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {formatStringField(userData.management?.regional?.name)}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Região/Diretoria
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item container xs={12} className="mt-6" alignItems="stretch">
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {formatStringField(userData.management?.name)}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Gerência
                </Typography>
              </Grid>
            </Grid>
            {startValidity && (
              <Grid item className={`mr-6 ${classes.fieldContainer}`}>
                <Grid item xs={12} className="mb-4">
                  <Typography variant="body1" className={classes.header}>
                    {startValidity ? format(new Date(startValidity), "dd/MM/yyyy") : "--"}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.fieldLabel}>
                  <Typography variant="caption" component="h5" className={classes.subtitle}>
                    Data da Vinculação
                  </Typography>
                </Grid>
              </Grid>
            )}
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {userData.license?.expireDate
                    ? format(new Date(userData.license?.expireDate), "dd/MM/yyyy")
                    : "--"}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Vencimento CNH
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {formatStringField(driverLicenseTypes.find(e => e.value === userData.license?.licenseTypeId)?.label)}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Tipo CNH
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {userData.course?.expireDate
                    ? format(new Date(userData.course?.expireDate), "dd/MM/yyyy")
                    : "--"}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Vencimento CDD
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {formatStringField(profileStyle.find(e => e.profile === userData.profile?.profileName)?.label)}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Perfil
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={`mr-6 ${classes.fieldContainer}`}>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className={classes.header}>
                  {userData.termsAcceptedAt
                    ? format(new Date(userData.termsAcceptedAt), "dd/MM/yyyy")
                    : "--"}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.fieldLabel}>
                <Typography variant="caption" component="h5" className={classes.subtitle}>
                  Data de assinatura dos termos
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  header: {
    color: DARK_GRAY
  },
  subtitle: {
    color: GRAY
  },
  noActiveDriver: {
    color: SECONDARY_COLOR
  },
  poleTag: {
    backgroundColor: "#e0e0e0",
    borderRadius: "16px",
    padding: 3,
    marginRight: "4px",
    display: "inline-block",
    fontSize: "12px"
  },
  fieldContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  fieldLabel: {
    marginTop: "auto"
  }
}));

export default UserDetailsContent;
